const initGamesAccordion = () => {
    const accordions = document.querySelectorAll('.js-games-accordion');
    
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        accordion.addEventListener('click', (e) => {
            const trigger = e.target.closest('.js-accordion-trigger');
            if (!trigger) return;

            const item = trigger.closest('.js-accordion-item');
            if (!item || item.classList.contains('is-active')) return;

            const activeItem = accordion.querySelector('.js-accordion-item.is-active');
            if (activeItem) {
                activeItem.classList.remove('is-active');
            }

            item.classList.add('is-active');
        });
    });
};

document.addEventListener('DOMContentLoaded', initGamesAccordion);